/* eslint-disable max-len */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Paper,
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { groupServices } from '../../../redux/services/groupServices';
import { uiActions } from '../../../redux/actions/uiActions';
import logo from '../../../shared/img/logo/logo.png';
import CoursePlan from './components/CoursePlan';
import Empty from '../Shared/Empty';

const CoursePlans = ({ user, setPageTitle, language }) => {
  const [courseInfosArr, setCourseInfosArr] = useState({});
  const [loading, setLoading] = useState({});
  const [expanded, setExpanded] = useState('panel1');
  setPageTitle('Plan(s) de formation');

  const getData = async () => {
    const groups = await groupServices.getGroupByUser(user._id);
    const courseInfos = [];
    await Promise.all(groups.map(async (group) => {
      if (group.language._id === language) {
        const coursePlanRes = await groupServices.getCoursePlan(group._id);
        if (coursePlanRes) courseInfos.push(coursePlanRes);
        const courseInfosSorted = courseInfos.sort((a, b) => new Date(b.coursePlan.beginDate) - new Date(a.coursePlan.beginDate));
        setCourseInfosArr(courseInfosSorted);
        setLoading(false);
      }
    }));
  };

  useEffect(async () => {
    getData();
  }, []);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <div>
      <Paper style={{ padding: '30px', marginBottom: '30px' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-end',
            justifyContent: 'flex-start',
            marginBottom: '20px',
          }}
        >
          <img src={logo} alt="logo english world" style={{ width: '100px' }} />
          <div>
            <Typography variant="body2" style={{ marginLeft: '30px', color: '#797979' }}>
              Vous pouvez trouver sur cette page la liste des
              groupes auxquels vous appartenez ou avez appartenu,
              ainsi que les plans de formation pour chacune de ces sessions.
              Vous pouvez également télécharger vos plans de formation au format PDF.
            </Typography>
          </div>
        </div>
      </Paper>
      {(loading === false && courseInfosArr.length > 0)
        ? courseInfosArr.map((courseInfo, index) => (
          <Accordion
            expanded={expanded === `panel${index + 1}`}
            onChange={handleChange(`panel${index + 1}`)}
          >
            <AccordionSummary
              expandIcon={<ExpandMore />}
            >
              <Typography>{courseInfo.name}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <CoursePlan courseInfos={courseInfo} />
            </AccordionDetails>
          </Accordion>

        ))
        : <Empty message="Désolé, vous n'avez pas de plan(s) de formation" />}
    </div>
  );
};

function mapState(state) {
  const { user } = state.user;
  const { language } = state.language;
  return {
    user,
    language,
  };
}

const actionCreators = {
  setPageTitle: uiActions.setPageTitle,
};

const connectedCoursePlans = connect(mapState, actionCreators)(CoursePlans);
export default connectedCoursePlans;
